import '~/services/datadog';
import '~/services/sentry';
import '~/locales/i18n';

import ReactDOM from 'react-dom/client';
import React, { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { MstProvider } from '~/contexts/mst_context';
import store from '~/mst/store';
import { reloadOnce, isChunkLoadError } from '~/utils/lazy_with_retry';
import App from './app';

import { CollapseDrawerProvider } from './contexts/collapse_drawer_context';

// The deploy prunes old hashed chunks, so a tab opened before it can no longer resolve the
// chunks its index.html points at. Vite fires this when the preload helper 404s.
window.addEventListener('vite:preloadError', () => {
  reloadOnce();
});

// Backstop for dynamic imports that don't go through the preload helper (and so never reach
// lazyWithRetry either) — without it those reject silently and the feature just never loads.
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    reloadOnce();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <HelmetProvider>
      <CollapseDrawerProvider>
        <BrowserRouter>
          <MstProvider store={store}>
            <App />
          </MstProvider>
        </BrowserRouter>
      </CollapseDrawerProvider>
    </HelmetProvider>
  </StrictMode>
);
